import { BrandLogo, BrandingLegalLinks } from '@blimo/ui';

/**
 * Login / 2FA / password pages: logo, compact card with title (20 px) and form, footer link below.
 * Same props as `AuthLayout` of @blimo/ui.
 * @param {{ appName: string, title: string, description?: import('react').ReactNode, children: import('react').ReactNode, footer?: import('react').ReactNode }} props
 */
export function PortalAuthLayout({ appName, title, description, children, footer }) {
  return (
    <main
      data-slot="portal-auth"
      className="flex min-h-dvh flex-col items-center justify-center bg-(--shell) px-4 pb-[calc(2.5rem+env(safe-area-inset-bottom))] pt-[calc(2.5rem+env(safe-area-inset-top))]"
    >
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex flex-col items-center gap-1">
          <BrandLogo className="h-14" />
          <span className="sr-only">{appName}</span>
        </div>
        <div className="flex flex-col gap-5 rounded-xl border bg-card p-6">
          <div className="flex flex-col gap-1">
            <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
            {description && <p className="text-[0.8125rem] text-muted-foreground">{description}</p>}
          </div>
          {children}
        </div>
        {footer && <div className="text-center text-[0.8125rem] text-muted-foreground">{footer}</div>}
        <BrandingLegalLinks />
      </div>
    </main>
  );
}
